import { render, staticRenderFns } from "./IdentificationForm.vue?vue&type=template&id=0ffbc017"
import script from "./IdentificationForm.vue?vue&type=script&lang=js"
export * from "./IdentificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports